import {loop, Effects} from 'redux-loop';
import chain from '@ersinfotech/chain';
import _ from 'lodash';
import {
  fetchLatestFeed,
  FETCH_LATEST_FEED,
  LATES_CLICK_MEDIATYPE,
  fetchFacebookLatestFeed,
  fetchNewsLatestFeed,
  FETCH_FACEBOOK_LATEST_FEED,
  FETCH_NEWS_LATEST_FEED,
  FETCH_INSTANT_NEWS_LATEST_FEED,
  FETCH_LATES_REPLIES_LATEST_FEED,
  fetchInstantNewsLatestFeed,
  fetchLatesRepliesLatestFeed,
  CHECK_SOURCE_GROUP,
  FETCH_INSTANT_NEWS_SOURCE_GROUP,
  FETCH_INSTANT_NEWS_SOURCE_GROUP_SUCCESS,
  CHECK_SUBJECT_ID
} from './actions';
import {reducer as feedReducer} from 'modules/feed';
import {fetchSourceGroupTasks} from './tasks';

export const initialState = {
  first: {
    feed: {},
  },
  news: {
    feed: {},
  },
  facebook: {
    feed: {},
  },
  instantNews: {
    feed: {},
  },
  latesReplies: {
    feed: {},
  },
  sourceGroup: ''
};

export default (state = initialState, action) => {
  if (action.type === FETCH_LATEST_FEED) {
    const [ feedModel, feedEffect ] = feedReducer(state.feed, action.action);
    return loop({
      ...state,
      first: {
        ...state.first,
        feed: feedModel
      },
    },
      Effects.batch([
        Effects.lift(feedEffect, fetchLatestFeed)
      ])
    )
  }

  if (action.type === FETCH_FACEBOOK_LATEST_FEED) {
    const [ feedModel, feedEffect ] = feedReducer(state.feed, action.action);
    return loop({
      ...state,
      facebook: {
        ...state.facebook,
        feed: feedModel
      },
    },
      Effects.batch([
        Effects.lift(feedEffect, fetchFacebookLatestFeed)
      ])
    )
  }

  if (action.type === FETCH_INSTANT_NEWS_LATEST_FEED) {
    const [ feedModel, feedEffect ] = feedReducer(state.feed, action.action);
    return loop({
      ...state,
      instantNews: {
        ...state.instantNews,
        feed: feedModel
      },
    },
      Effects.batch([
        Effects.lift(feedEffect, fetchInstantNewsLatestFeed)
      ])
    )
  }
  if (action.type === FETCH_LATES_REPLIES_LATEST_FEED) {
    const [ feedModel, feedEffect ] = feedReducer(state.feed, action.action);
    return loop({
      ...state,
      latesReplies: {
        ...state.latesReplies,
        feed: feedModel
      },
    },
      Effects.batch([
        Effects.lift(feedEffect, fetchLatesRepliesLatestFeed)
      ])
    )
  }

  if (action.type === FETCH_NEWS_LATEST_FEED) {
    const [ feedModel, feedEffect ] = feedReducer(state.feed, action.action);
    return loop({
      ...state,
      news: {
        ...state.news,
        feed: feedModel
      },
    },
      Effects.batch([
        Effects.lift(feedEffect, fetchNewsLatestFeed)
      ])
    )
  }

  if (action.type === LATES_CLICK_MEDIATYPE) {
    return loop({
      ...state,
      mediaType: action.mediaType
    },
      Effects.none()
    )
  }

  if (action.type === CHECK_SOURCE_GROUP) {
    return loop({
      ...state,
      sourceGroup: action.sourceGroup
    },
      Effects.none()
    )
  }
  if (action.type === CHECK_SUBJECT_ID) {
    return loop({
      ...state,
      subjectId: action.subjectId
    },
      Effects.none()
    )
  }

  // FETCH_INSTANT_NEWS_SOURCE_GROUP
// FETCH_INSTANT_NEWS_SOURCE_GROUP_SUCCESS

  if (action.type === FETCH_INSTANT_NEWS_SOURCE_GROUP) {
    return loop({
      ...state,
    },
      Effects.promise(fetchSourceGroupTasks, action.data)
    )
  }

  if (action.type === FETCH_INSTANT_NEWS_SOURCE_GROUP_SUCCESS) {
    const entities = chain(action.data)
      .thru(_.groupBy, 'mediaType')
      .thru(_.mapValues, (groups) => _.keyBy(groups, 'name'))
      .value();
    return loop({
      ...state,
      instantNews: {
        ...state.instantNews,
        sourceGroup: {
          entities,
          byId: _.keyBy(action.data, 'id'),
        }
      },
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/reducer.js
 **/